import * as yup from 'yup'

const schemaOrganizationCompany = yup.object().shape({
  company: yup.object().required(),
})

export default schemaOrganizationCompany
